import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconCameraComponent } from "./med-icon-camera.component";

@NgModule({
  declarations: [
    MedIconCameraComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconCameraComponent,
  ],
})
export class MedIconCameraModule { }
